export const TranslatorValues = (value) => {
    switch(value){
        case "doctor":
            return "Лікар";

        case "laboratoryAssistant":
            return "Лаборант";

        case "assistant":
            return "Помічник лаборанта";

        case "doctorPathologist":
            return "Лікар-патологоанатом";

        case "doctorPathologistChild":
            return "Лікар-патологоанатом дитячий";

        case "medicalDirector":
            return "Медичний директор";

        case "admin":
            return "Адміністратор";

        case "registrar":
            return "Реєстратор медичний";

        case "registered":
            return "Зареєстроване скерування";

        case "scanAfterForm":
            return "Сформована форма";

        case "scanBeforePaint":
            return "Готові до фарбування";

        case "scanAfterPaint":
            return "Пофарбовані";

        case "toDoctor":
            return "Направлені до лікаря";

        case "finished":
            return "Завершені";

        case "true":
            return "Так";

        case "false":
            return "Ні";

        default:
            return value;
    }
}